module.exports = __webpack_public_path__ + "img/horizontal_6_2_8004.01e5c8fa.png";